import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { Provider } from "react-redux";
import store from "./redux/store.js";
import "./index.css";
import NoInternetConnection from "./components/NoInternetConnection.js";
import { createRoot } from "react-dom/client";

const root = createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <NoInternetConnection>
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  </NoInternetConnection>
  // </React.StrictMode>
);
